import React from "react";
import { Wrench, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const WorkInProgress = () => {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center bg-[#f5f5f5] dark:bg-slate-900 text-[#111011] dark:text-white px-6 py-20 font-[Inter] transition-colors">
      <div className="text-center">
        <div className="flex items-center justify-center mb-6">
          <Wrench size={36} className="text-[#111011] dark:text-white mr-2" />
          <Clock size={36} className="text-[#111011] dark:text-white" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-[DM Sans] font-bold mb-4">
          This Page is Under Construction
        </h1>
        <p className="text-gray-600 dark:text-gray-300 text-base sm:text-lg mb-6 max-w-md mx-auto">
          We're working hard to build something amazing here. Please check back soon or explore other parts of the site in the meantime.
        </p>
        <Link
          to="/"
          className="inline-block px-5 py-2 text-sm font-medium text-white bg-[#111011] dark:bg-slate-800 hover:bg-[#333] dark:hover:bg-slate-700 rounded-md transition"
        >
          ← Return to Homepage
        </Link>
      </div>
    </section>
  );
};

export default WorkInProgress;
